import AdjustButton from "./AdjustButton";

type PeriodProps = {
	period: number;
	isCompact?: boolean;
	handleAddPeriod: () => void;
	handleRemovePeriod: () => void;
};

const Period = ({
	period,
	isCompact = false,
	handleAddPeriod,
	handleRemovePeriod,
}: PeriodProps) => (
	<div className="flex flex-row gap-4 items-center">
		<AdjustButton
			isSquare
			icon="minus"
			onClick={handleRemovePeriod}
			disabled={period <= 1}
			isCompact={isCompact}
		/>
		{period || "1"}
		<AdjustButton isSquare icon="plus" onClick={handleAddPeriod} isCompact={isCompact} />
	</div>
);

export default Period;
